import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readBillSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 수금 방법 셀렉트박스
 * @param props
 * @returns
 */
export const useReadBillSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readBillSelect"],
        queryFn: async () => await readBillSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
